// base
import { createContext } from 'react';

export interface PkgContextProps {
  pkgNo: string | null;
  setPkgNo?: (pkgNo: string) => void;
}

export const PkgContext = createContext<PkgContextProps>({
  pkgNo: null,
  setPkgNo: () => {}
});
